import Helper from './Helper';

class Accordion {
  constructor(config = {}) {
    const {
      accordions,
    } = config;
    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.currentEl = null;
    if(this.accordions && this.accordions.length !== 0){
      this.checkForAnchor(accordions);
      this.bindEvents();
    }
  }

  checkForAnchor(accordions){
    if(window.location.hash) {
      const anchor = window.location.hash;
      const currentAnchor = document.querySelector(`${anchor}`);

      if(!currentAnchor) {
        return;
      }
      currentAnchor.children[0].classList.add('active');
      Helper.slideOpen(currentAnchor.children[1], true);
      currentAnchor.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }
  }

  bindEvents() {
    this.accordions.forEach(el => {
      el.addEventListener('click', (e) => {
        if(el.classList.contains('active')){
          Helper.slideClose(el.nextElementSibling);
          el.classList.remove('active');
        } else{
          el.classList.add('active');
          Helper.slideOpen(el.nextElementSibling, true);
        }
      });
    });
  }

}

export default Accordion;
